export default __webpack_public_path__ + "c4860ed20fc258328d035b0cdaab623d.svg";